async function refreshCartUI() {
  const CANDIDATE_SECTIONS = ['cart-drawer', 'cart-icon-bubble', 'cart-notification'];
  const sections = CANDIDATE_SECTIONS.filter(id =>
    document.getElementById(`shopify-section-${id}`)
  );
  if (!sections.length) return;

  const url = `${window.location.pathname}?sections=${sections.join(',')}`;
  const res = await fetch(url, { headers: { 'Cache-Control': 'no-cache' } });
  if (!res.ok) return;

  const htmlById = await res.json();

  sections.forEach((id) => {
    const container = document.getElementById(`shopify-section-${id}`);
    if (container && htmlById[id]) container.innerHTML = htmlById[id];
  });

  const drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
  }
}

await refreshCartUI();

try {
  const cart = await (await fetch('/cart.js', { headers: { 'Cache-Control': 'no-cache' } })).json();
  document.querySelectorAll('[data-cart-count]').forEach(el => (el.textContent = cart.item_count));
  if (window.Shopify && Shopify.formatMoney) {
    document.querySelectorAll('[data-cart-total]').forEach(el => (el.textContent = Shopify.formatMoney(cart.total_price)));
  }
} catch (_) {}
